import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AdminInteraction, ContractInfo } from '../../../../services/interactions.service';
import { CallCenterChipComponent, CallCenterChipConfig } from '../../../../shared/components/call-center-chip/call-center-chip.component';

@Component({
  selector: 'app-extended-logs-table',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatPaginatorModule,
    MatSnackBarModule,
    MatTooltipModule,
    CallCenterChipComponent
  ],
  templateUrl: './extended-logs-table.component.html',
  styleUrl: './extended-logs-table.component.scss'
})
export class ExtendedLogsTableComponent implements OnInit, OnChanges {
  @Input() paginatedLogs: AdminInteraction[] = [];
  @Input() loading: boolean = false;
  @Input() error: string | null = null;
  @Input() totalLogs: number = 0;

  constructor(private snackBar: MatSnackBar) {}
  
  ngOnInit() {
    
  }

  ngOnChanges(changes: SimpleChanges) {
    
  }

  
  @Input() pageSize: number = 10;
  @Input() pageIndex: number = 0;
  @Input() pageSizeOptions: number[] = [5, 10, 25, 50];
  @Input() hidePaginator: boolean = false;

  @Output() pageChange = new EventEmitter<PageEvent>();

  // Közös mapping objektum a státusz alapú ikon és osztály meghatározáshoz
  private readonly statusIconMapping: { [key: string]: { icon: string; class: string } } = {
    'adatok feltöltése': { icon: 'edit', class: 'log-edit-icon' },
    'adatok kiegészítése': { icon: 'extension', class: 'log-edit-icon' },
    'excel adatok feltöltése': { icon: 'edit', class: 'log-edit-icon' },
    'adat feltöltés': { icon: 'edit', class: 'log-edit-icon' },
    'céginformációk módosítva': { icon: 'business', class: 'log-edit-icon' },
    'ügyfél adatai módosítva': { icon: 'person', class: 'log-edit-icon' },
    'státusz módosítása': { icon: 'update', class: 'log-update-icon' },
    'státusz változás': { icon: 'update', class: 'log-update-icon' },
    'status change': { icon: 'update', class: 'log-update-icon' },
    'nem_vette_fel': { icon: 'phone_missed', class: 'log-phone-missed-icon' },
    'robinson_listas': { icon: 'block', class: 'log-blocked-icon' },
    'egyeztetett': { icon: 'event', class: 'log-event-icon' },
    'egyeztetett (v)': { icon: 'event', class: 'log-event-icon' },
    'egyeztetett-v': { icon: 'event', class: 'log-event-icon' },
    'telefonhívás': { icon: 'phone', class: 'log-phone-icon' },
    'hívás': { icon: 'phone', class: 'log-phone-icon' },
    'telefon': { icon: 'phone', class: 'log-phone-icon' },
    'Kontakt hozzáadás': { icon: 'add', class: 'log-contact-added-icon' },
    'email': { icon: 'email', class: 'log-email-icon' },
    'e-mail': { icon: 'email', class: 'log-email-icon' },
    'találkozó': { icon: 'event', class: 'log-event-icon' },
    'meeting': { icon: 'event', class: 'log-event-icon' },
    'fizetés': { icon: 'payment', class: 'log-payment-icon' },
    'payment': { icon: 'payment', class: 'log-payment-icon' },
    'megjegyzés': { icon: 'note', class: 'log-note-icon' },
    'note': { icon: 'note', class: 'log-note-icon' },
    'dokumentum': { icon: 'description', class: 'log-document-icon' },
    'document': { icon: 'description', class: 'log-document-icon' },
    'szerződés': { icon: 'assignment', class: 'log-contract-icon' },
    'contract': { icon: 'assignment', class: 'log-contract-icon' },
    'Szerződés hozzáadása': { icon: 'assignment', class: 'log-contract-icon' },
    'Szerződés frissítése': { icon: 'assignment_turned_in', class: 'log-contract-icon' },
    'termék hozzáadás': { icon: 'add_circle', class: 'log-add-icon' },
    'termék létrehozás': { icon: 'add_circle', class: 'log-add-icon' },
    'termék módosítás': { icon: 'edit', class: 'log-edit-icon' },
    'termék frissítés': { icon: 'edit', class: 'log-edit-icon' },
    'termék törlés': { icon: 'delete', class: 'log-delete-icon' },
    'biztosító hozzáadás': { icon: 'add_business', class: 'log-add-icon' },
    'biztosító létrehozás': { icon: 'add_business', class: 'log-add-icon' },
    'biztosító módosítás': { icon: 'edit', class: 'log-edit-icon' },
    'biztosító frissítés': { icon: 'edit', class: 'log-edit-icon' },
    'biztosító törlés': { icon: 'delete', class: 'log-delete-icon' },
    'új esemény létrehozása': { icon: 'event', class: 'log-event-icon' },
    'esemény módosítása': { icon: 'edit_calendar', class: 'log-event-icon' },
    'esemény törlése': { icon: 'event_busy', class: 'log-delete-icon' },
    'felhasználó létrehozása': { icon: 'person_add', class: 'log-add-icon' },
    'felhasználó módosítása': { icon: 'person', class: 'log-edit-icon' },
    'felhasználó törlése': { icon: 'person_remove', class: 'log-delete-icon' },
    'kontakt módosítás': { icon: 'edit', class: 'log-edit-icon' },
    'tervszám módosítás': { icon: 'edit_note', class: 'log-edit-icon' },
    'tényszám módosítás': { icon: 'trending_up', class: 'log-edit-icon' },
    'új megjegyzés': { icon: 'note_add', class: 'log-note-icon' },
    'megjegyzés szerkesztése': { icon: 'edit_note', class: 'log-note-icon' },
    'megjegyzés törlése': { icon: 'delete', class: 'log-delete-icon' }
  };

  formatDate(date: string | Date): string {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return dateObj.toLocaleDateString('hu-HU', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  formatDateOnly(date: string | Date): string {
    if (!date) return '';
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return dateObj.toLocaleDateString('hu-HU', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
  }

  isIllustrationLog(log: AdminInteraction): boolean {
    if (log.status !== 'Új illusztráció' || !log.affected_entities) {
      return false;
    }
    
    // Kezelni kell mind az objektum, mind a tömb esetét
    if (Array.isArray(log.affected_entities)) {
      return log.affected_entities.length > 0 && log.affected_entities[0]?.illustration_id;
    } else {
      return log.affected_entities.illustration_id;
    }
  }

  getIllustrationData(log: AdminInteraction): any {
    if (!log.affected_entities) return null;
    return Array.isArray(log.affected_entities) ? log.affected_entities[0] : log.affected_entities;
  }

  getHistoryIcon(status: string, log?: AdminInteraction): string {
    const lowerStatus = status?.toLowerCase();
    
    // Státusz módosítása mindig update ikont kap
    if (lowerStatus === 'státusz módosítása') {
      return 'update';
    }
    
    // Egyéb státuszok esetén nézzük az affected_entities-t új kontakt/ügyfél hozzáadáshoz
    if (log?.affected_entities) {
      const hasNewContact = log.affected_entities.some((entity: any) => 
        entity.type === 'contact_added' || 
        entity.type === 'customer_added'
      );
      
      if (hasNewContact) {
        return 'add';
      }
    }
    
    const mapping = this.statusIconMapping[lowerStatus];
    return mapping ? mapping.icon : 'history';
  }

  getIconClass(status: string, log?: AdminInteraction): string {
    const lowerStatus = status?.toLowerCase();
    
    // Státusz módosítása mindig update ikont kap
    if (lowerStatus === 'státusz módosítása') {
      return 'log-update-icon';
    }
    
    // Egyéb státuszok esetén nézzük az affected_entities-t új kontakt/ügyfél hozzáadáshoz
    if (log?.affected_entities) {
      const hasNewContact = log.affected_entities.some((entity: any) => 
        entity.type === 'contact_added' || 
        entity.type === 'customer_added'
      );
      
      if (hasNewContact) {
        return 'log-add-icon';
      }
    }
    
    const mapping = this.statusIconMapping[lowerStatus];
    return mapping ? mapping.class : 'log-history-icon';
  }

  getStatusBadgeClass(status: string): string {
    const lowerStatus = status.toLowerCase();
    
    if (lowerStatus === 'egyeztetett') {
      return 'status-badge egyeztetett-badge';
    }
    if (lowerStatus === 'egyeztetett (v)' || lowerStatus === 'egyeztetett-v') {
      return 'status-badge egyeztetett-v-badge';
    }
    if (lowerStatus === 'megjegyzés törlése') {
      return 'status-badge log-note-icon-badge';
    }
    
    const iconClass = this.getIconClass(status);
    return `status-badge ${iconClass}-badge`;
  }

  createStatusChipConfig(statusName: string): CallCenterChipConfig {
    return {
      text: statusName,
      type: 'status'
    };
  }

  // KUM státusz technikai értékek -> emberi szöveg leképezés
  private static readonly KUM_STATUS_LABELS: { [key: string]: string } = {
    'elso_targyalasra_var': 'Első tárgyalásra vár'
  };

  getKumStatusLabel(status: string): string {
    return ExtendedLogsTableComponent.KUM_STATUS_LABELS[status] || status;
  }

  createKumStatusChipConfig(statusName: string): CallCenterChipConfig {
    return {
      text: this.getKumStatusLabel(statusName),
      type: 'status'
    };
  }

  onPageChange(event: PageEvent) {
    this.pageChange.emit(event);
  }

  // Object hozzáférés a template számára
  Object = Object;

  // Változás címkék magyar fordítása
  getChangeLabel(changeKey: string): string {
    const changeLabels: { [key: string]: string } = {
      'productcode': 'Termék kód',
      'productname': 'Termék név',
      'producttype': 'Termék típus',
      'insurancecompanyid': 'Biztosító társaság'
    };
    
    return changeLabels[changeKey] || changeKey;
  }

  // Céginformációk változásainak feldolgozása
  getCompanyChanges(changes: any): Array<{field: string, before: any, after: any}> {
    if (!changes) return [];
    
    return Object.keys(changes).map(field => ({
      field: field,
      before: changes[field].before,
      after: changes[field].after
    }));
  }

  // Mező magyar elnevezések
  getFieldDisplayName(field: string): string {
    const fieldNames: { [key: string]: string } = {
      // Céginformációk
      'companyname': 'Cégnév',
      'taxNumber': 'Adószám',
      'registrationNumber': 'Cégjegyzékszám',
      'address': 'Cím',
      'mainActivity': 'Főtevékenység',
      'county': 'Megye',
      'netRevenue': 'Nettó árbevétel',
      'employeeCount': 'Alkalmazottak száma',
      
      // Céginformációk adatbázis oszlopnévvel (Excel kiegészítés logja)
      'taxnumber': 'Adószám',
      'companyregistrationnumber': 'Cégjegyzékszám',
      'opten_id': 'Opten ID',
      'mainactivity': 'Főtevékenység',
      'netrevenue': 'Nettó árbevétel',
      'employeecount': 'Alkalmazottak száma',
      'kum_status': 'KÜM státusz',
      
      // Magánszemély adatok
      'fullName': 'Név',
      'birthDate': 'Születési dátum',
      'birthPlace': 'Születési hely',
      'motherName': 'Anyja neve'
    };
    
    return fieldNames[field] || field;
  }

  // User mezők magyar elnevezései
  getUserFieldLabel(field: string): string {
    const fieldNames: { [key: string]: string } = {
      'username': 'Felhasználónév',
      'fullname': 'Teljes név',
      'email': 'Email cím',
      'phone_number': 'Telefonszám',
      'job_title': 'Munkakör',
      'is_active': 'Aktív státusz'
    };
    
    return fieldNames[field] || field;
  }

  // Before érték formázása - üres string esetén "-" jel
  formatBeforeValue(value: any): string {
    if (value === '' || value === null || value === undefined) {
      return '-';
    }
    return String(value);
  }

  // Pénzösszeg formázása
  formatCurrency(amount: number, currency: string = 'HUF'): string {
    if (!amount || amount === 0) {
      return `0 ${currency}`;
    }
    return `${amount.toLocaleString('hu-HU')} ${currency}`;
  }

  // Nettó árbevétel formázása - az érték ezer Ft (eFt) mértékegységben van tárolva
  formatNetRevenue(value: any): string {
    const parsed = Number(value);
    if (value === null || value === undefined || value === '' || isNaN(parsed) || parsed === 0) {
      return '-';
    }

    const millions = parsed / 1000;
    const fractionDigits = Math.abs(millions) < 1 ? 1 : 0;

    return `${millions.toLocaleString('hu-HU', {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits
    })} M Ft`;
  }

  // Numerikus érték ellenőrzése (JSONB-ből string és szám is érkezhet)
  hasNumericValue(value: any): boolean {
    const parsed = Number(value);
    return value !== null && value !== undefined && value !== '' && !isNaN(parsed) && parsed !== 0;
  }

  // Mező értékének megjelenítése a mező típusa alapján
  getFieldDisplayValue(field: string, value: any): string {
    if (field === 'netrevenue' || field === 'netRevenue') {
      return this.formatNetRevenue(value);
    }
    return String(value);
  }

  // Szerződés mezők dinamikus megjelenítése
  getContractFields(contractInfo: ContractInfo): Array<{key: string, label: string, value: string, icon: string}> {
    if (!contractInfo) {
      return [];
    }

    const fieldMapping: {[key: string]: {label: string, icon: string, formatter?: (value: any) => string}} = {
      'contract_id': { label: 'Szerződés ID', icon: 'tag' },
      'policynumber': { label: 'Kötvény szám', icon: 'confirmation_number' },
      'status': { label: 'Státusz', icon: 'info' },
      'startdate': { label: 'Kezdő dátum', icon: 'event', formatter: (v) => this.formatDateOnly(v) },
      'enddate': { label: 'Befejező dátum', icon: 'event_busy', formatter: (v) => this.formatDateOnly(v) },
      'settlementdate': { label: 'Elszámolási dátum', icon: 'receipt_long', formatter: (v) => this.formatDateOnly(v) },
      'insurancepremium': { label: 'Biztosítási díj', icon: 'payments', formatter: (v) => this.formatCurrency(v, contractInfo.currency) },
      'annualpremium': { label: 'Éves díj', icon: 'calendar_today', formatter: (v) => this.formatCurrency(v, contractInfo.currency) },
      'currency': { label: 'Pénznem', icon: 'attach_money' },
      'paymentfrequency': { label: 'Díjfizetési gyakoriság', icon: 'schedule' },
      'product': { label: 'Termék', icon: 'category' },
      'insurancecompany': { label: 'Biztosító', icon: 'business' },
      'policyholdercustomer': { label: 'Szerződő ügyfél', icon: 'person' },
      'policyholdercompany': { label: 'Szerződő cég', icon: 'business' },
      'insuredcustomer': { label: 'Biztosított ügyfél', icon: 'person_outline' },
      'insuredcompany': { label: 'Biztosított cég', icon: 'business_center' }
    };

    const fields: Array<{key: string, label: string, value: string, icon: string}> = [];

    // Prioritási sorrend - először a fontosabb mezőket
    const priorityOrder = [
      'contract_id', 'policynumber', 'status', 'startdate', 'enddate', 'settlementdate',
      'insurancecompany', 'product', 'insurancepremium', 'annualpremium', 'currency', 'paymentfrequency',
      
      // Csak a nevek, ID-k nélkül
      'policyholdercustomer', 'policyholdercompany', 'insuredcustomer', 'insuredcompany'
    ];

    // Először a prioritásos mezőket dolgozzuk fel
    for (const key of priorityOrder) {
      if (contractInfo[key] !== null && contractInfo[key] !== undefined && contractInfo[key] !== '' && key !== 'operation') {
        const mapping = fieldMapping[key];
        if (mapping) {
          let value = contractInfo[key];
          if (mapping.formatter) {
            value = mapping.formatter(value);
          }
          fields.push({
            key: key,
            label: mapping.label,
            value: String(value),
            icon: mapping.icon
          });
        }
      }
    }

    // Ezután a többi mezőt (ami nincs a prioritásos listában), de kizárjuk az ID mezőket
    const excludedFields = ['operation', 'productid', 'insurancecompanyid', 'policyholdercustomerid', 
                           'policyholdercompanyid', 'insuredcustomerid', 'insuredcompanyid'];
    
    for (const key in contractInfo) {
      if (contractInfo[key] !== null && contractInfo[key] !== undefined && contractInfo[key] !== '' && 
          !excludedFields.includes(key) && !priorityOrder.includes(key)) {
        fields.push({
          key: key,
          label: key.charAt(0).toUpperCase() + key.slice(1), // Capitalize first letter
          value: String(contractInfo[key]),
          icon: 'info'
        });
      }
    }

    return fields;
  }

  // Helper metódus Object.keys használatához
  getObjectKeys(obj: any): string[] {
    return Object.keys(obj || {});
  }

  // Helper metódus Array.isArray használatához
  isArray(obj: any): boolean {
    return Array.isArray(obj);
  }

  // Helper metódus a hét napjainak helyes sorrendben történő visszaadásához
  getSortedDays(metricData: any): string[] {
    const dayOrder = ['Hétfő', 'Kedd', 'Szerda', 'Csütörtök', 'Péntek'];
    const availableDays = Object.keys(metricData || {});
    
    // Csak azok a napok, amelyek léteznek az adatokban, a helyes sorrendben
    return dayOrder.filter(day => availableDays.includes(day));
  }

  // Mező label lekérése
  getFieldLabel(fieldKey: string): string {
    const fieldMapping: {[key: string]: string} = {
      'status': 'Státusz',
      'startdate': 'Kezdő dátum',
      'enddate': 'Befejező dátum',
      'settlementdate': 'Elszámolási dátum',
      'insurancepremium': 'Biztosítási díj',
      'annualpremium': 'Éves díj',
      'currency': 'Pénznem',
      'paymentfrequency': 'Díjfizetési gyakoriság'
    };
    
    return fieldMapping[fieldKey] || fieldKey.charAt(0).toUpperCase() + fieldKey.slice(1);
  }

  // Mező ikon lekérése
  getFieldIcon(fieldKey: string): string {
    const iconMapping: {[key: string]: string} = {
      'status': 'info',
      'startdate': 'event',
      'enddate': 'event_busy',
      'settlementdate': 'receipt_long',
      'insurancepremium': 'payments',
      'annualpremium': 'calendar_today',
      'currency': 'attach_money',
      'paymentfrequency': 'schedule'
    };
    
    return iconMapping[fieldKey] || 'edit';
  }

  // Ellenőrzi, hogy vannak-e kontakt változások az affected_entities-ben
  hasContactChanges(entities: any[]): boolean {
    return entities.some(entity => 
      entity.type === 'contact_validated' || entity.type === 'contact_added' || entity.type === 'contact_edited'
    );
  }

  // Visszaadja a napneveket a megjegyzés affected_entities-ből (meta-mezők kizárásával)
  getNoteChangeDays(entities: any): string[] {
    if (!entities) return [];
    const metaKeys = new Set(['modul', 'user_name', 'target_user_id', 'év', 'hónap', 'nap_index', 'is_kum_mode',
      'régi_megjegyzés', 'új_megjegyzés', 'törölt_megjegyzés']);
    const dayOrder = ['Hétfő', 'Kedd', 'Szerda', 'Csütörtök', 'Péntek'];
    return dayOrder.filter(day => !metaKeys.has(day) && entities[day] && typeof entities[day] === 'object');
  }

  // Eltávolítja a színes prefix-eket a megjegyzésből (pl. red:, green:, yellow:)
  stripNotePrefix(note: string | null | undefined): string {
    if (!note) return '';
    return note.replace(/^[a-z]+:\s*/i, '').trim();
  }

  // "Adatok feltöltése" log tartalmának másolása a vágólapra
  copyLogContent(event: MouseEvent): void {
    event.stopPropagation();
    const button = event.currentTarget as HTMLElement;
    const container = button.closest('.changes-container');
    if (!container) return;

    // A copy gomb és mat-icon elemek szövegét kizárjuk a másolandó tartalomból
    const clone = container.cloneNode(true) as HTMLElement;
    const copyBtn = clone.querySelector('.copy-log-btn');
    if (copyBtn) copyBtn.remove();
    clone.querySelectorAll('mat-icon').forEach(icon => icon.remove());

    // Soronként gyűjtjük a szöveget, ahogy a containerben is megjelennek az elemek
    const lines: string[] = [];
    const lineSelectors = '.detail-item, .customer-simple-text, .email-item, .phone-item, .change-item, .field-change';
    const allMatched = Array.from(clone.querySelectorAll(lineSelectors));

    // Csak a levél elemeket tartjuk meg: kiszűrjük azokat, amelyek más találatot tartalmaznak
    const leafElements = allMatched.filter(el =>
      !allMatched.some(other => other !== el && el.contains(other))
    );

    if (leafElements.length > 0) {
      leafElements.forEach(el => {
        const text = (el as HTMLElement).innerText.trim();
        if (text) lines.push(text);
      });
    } else {
      // Fallback: ha nincs ismert elem, az egész szöveget másoljuk
      lines.push(clone.innerText.trim());
    }

    const text = lines.join('\n');
    navigator.clipboard.writeText(text).then(() => {
      this.snackBar.open('Tartalom a vágólapra másolva!', 'OK', {
        duration: 2500,
        horizontalPosition: 'center',
        verticalPosition: 'bottom'
      });
    }).catch(() => {
      this.snackBar.open('Másolás sikertelen!', 'OK', {
        duration: 2500,
        horizontalPosition: 'center',
        verticalPosition: 'bottom'
      });
    });
  }
}